/* cadian-cart-drawer.js — V4 drawer interactions.
   The drawer body is server-rendered Liquid; every cart mutation re-fetches
   the cart-drawer section and swaps it in (same contract as Dawn's
   renderContents). This file only wires events (delegated, so they survive
   re-renders) and the compact checkout controls. */
function paintCadianCartIcon(count) {
  var a = document.getElementById('cart-icon-bubble');
  if (!a) return;
  var n = parseInt(count, 10) || 0;
  a.classList.toggle('has-items', n > 0);
  var badge = a.querySelector('.cad-nav__cart-count');
  if (!badge) return;
  badge.textContent = String(n);
  if (n > 0) badge.removeAttribute('hidden');
  else badge.setAttribute('hidden', '');
}
window.paintCadianCartIcon = paintCadianCartIcon;

(function () {
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var busy = false;
  var previousTotal = null;
  var lockedControls = new Set();
  var checkoutSelector = '[name="checkout"], [data-checkout], #nvd-with-checkout-btn, #nvd-without-checkout-btn, a[href="/checkout"], .additional-checkout-buttons, shopify-accelerated-checkout-cart';
  var mutationSelector = '[data-qty-inc], [data-qty-dec], [data-line-remove], [data-mode-one], [data-mode-sub], [data-upsell-add], cart-remove-button a, input[name="updates[]"], cart-items .quantity__button, [data-cad-discount-apply], [data-cad-discount-remove], [data-cad-discount-input]';

  function syncBusy() {
    if (busy) document.querySelectorAll(checkoutSelector + ', ' + mutationSelector).forEach(function (el) {
      if (!el.disabled && !lockedControls.has(el)) {
        lockedControls.add(el);
        el.disabled = true;
        el.setAttribute('aria-disabled', 'true');
      }
    });
    var d = drawerEl();
    if (d) {
      if (busy) d.setAttribute('aria-busy', 'true');
      else d.removeAttribute('aria-busy');
    }
    document.querySelectorAll('[data-cart-update-status]').forEach(function (el) { el.hidden = !busy; });
    document.querySelectorAll('.additional-checkout-buttons, shopify-accelerated-checkout-cart').forEach(function (el) { el.inert = busy; });
  }
  function beginUpdate() {
    if (busy) return false;
    previousTotal = document.getElementById('CartDrawer')?.getAttribute('data-cart-total');
    busy = true;
    syncBusy();
    return true;
  }
  function endUpdate() {
    busy = false;
    var priceChanged = previousTotal !== document.getElementById('CartDrawer')?.getAttribute('data-cart-total');
    lockedControls.forEach(function (el) {
      // A retained full-cart widget can still quote the old protection tier.
      // Navidium replaces it once its new quote arrives; leave that old CTA locked.
      if (priceChanged && el.isConnected && el.id === 'nvd-with-checkout-btn') {
        var label = el.querySelector('#nvd-subtotal');
        if (label) label.textContent = 'Updating delivery upgrade…';
        var upgradeSummary = el.querySelector('.cad-delivery-summary');
        if (upgradeSummary) upgradeSummary.hidden = true;
        return;
      }
      el.disabled = false;
      el.removeAttribute('aria-disabled');
    });
    lockedControls.clear();
    syncBusy();
  }
  window.CadianCartUI = { begin: beginUpdate, end: endUpdate, busy: function () { return busy; } };
  document.addEventListener('click', function (e) {
    if (busy && e.target.closest(checkoutSelector + ', ' + mutationSelector)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', function (e) {
    if (busy && (e.target.id === 'cart' || e.target.id === 'CartDrawer-Form' || e.target.matches('[data-cad-discount-form]'))) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function swapSections(res, keepClosed) {
    if (Array.isArray(res.discount_codes)) discountCodes = res.discount_codes;
    discountFeedback = null;
    var d = drawerEl();
    if (!d) return;
    var oldBody = d.querySelector('[data-cad-body]');
    var scrollTop = oldBody ? oldBody.scrollTop : 0;
    var focused = d.contains(document.activeElement);
    var focusedLine = focused && document.activeElement.closest('[data-line-key]');
    var focusedKey = focusedLine && focusedLine.getAttribute('data-line-key');
    var focusedAction = focused && ['data-qty-inc', 'data-qty-dec', 'data-line-remove', 'data-mode-one', 'data-mode-sub'].find(function (attr) { return document.activeElement.hasAttribute(attr); });
    if (res.sections && res.sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var cur = d.querySelector('#CartDrawer');
      if (fresh && cur) cur.replaceWith(fresh);
      var freshDrawer = doc.querySelector('cart-drawer');
      d.classList.toggle('is-empty', freshDrawer ? freshDrawer.classList.contains('is-empty') : res.item_count === 0);
    }
    if (res.sections && res.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) bubble.innerHTML = new DOMParser()
        .parseFromString(res.sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section').innerHTML;
    }
    if (typeof res.item_count === 'number') paintCadianCartIcon(res.item_count);
    else if (res.sections && res.sections['cart-icon-bubble']) {
      var badge = document.querySelector('#cart-icon-bubble .cad-nav__cart-count');
      if (badge) paintCadianCartIcon(parseInt(badge.textContent, 10) || 0);
    }
    if (!keepClosed && typeof d.open === 'function' && !d.classList.contains('active')) d.open();
    var nextBody = d.querySelector('[data-cad-body]');
    if (nextBody) nextBody.scrollTop = scrollTop;
    if (focused && d.classList.contains('active') && typeof trapFocus === 'function') {
      var nextLine = Array.prototype.find.call(d.querySelectorAll('[data-line-key]'), function (line) { return line.getAttribute('data-line-key') === focusedKey; });
      trapFocus(d.querySelector('.drawer__inner'), (nextLine && focusedAction && nextLine.querySelector('[' + focusedAction + ']')) || d.querySelector('.drawer__close'));
    }
    placeNavidium();
    syncBusy();
    document.dispatchEvent(new CustomEvent('cadian:cart-rendered', { detail: res }));
  }

  function mutate(url, body) {
    body.sections = SECTIONS.slice();
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var section = document.getElementById(id);
      if (section && section.dataset.id) body.sections.push(section.dataset.id);
    });
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (res) {
        if (!r.ok || (res.status && res.status >= 400)) {
          var error = new Error(res.description || res.message || 'Unable to update your cart.');
          error.cartMessage = true;
          throw error;
        }
        return res;
      });
    });
  }


  // Cart totals come from the rendered Shopify cart; never reconstruct offer savings.
  var discountCodes = null;
  var discountFeedback = null;
  function cartState(root) {
    var node = root.querySelector('[data-cad-cart-state]');
    try { return node ? JSON.parse(node.textContent) : null; } catch (_) { return null; }
  }
  function cartMoney(cents, state) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency', currency: state.currency || 'AUD', currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (_) { return '$' + (cents / 100).toFixed(2); }
  }
  function quoteCents(text) {
    var amount = String(text || '').replace(/[^\d.,]/g, '');
    if (!amount) return null;
    var decimal = amount.match(/[.,](\d{1,2})$/);
    var normalized = decimal ? amount.slice(0, decimal.index).replace(/[.,]/g, '') + '.' + decimal[1] : amount.replace(/[.,]/g, '');
    var value = Number(normalized);
    return Number.isFinite(value) ? Math.round(value * 100) : null;
  }
  function renderDiscounts(root, state) {
    var codes = discountCodes || state.codes || [];
    root.querySelectorAll('[data-cad-discount-form]').forEach(function (form) {
      var holder = form.querySelector('[data-cad-discount-codes]');
      var signature = JSON.stringify(codes);
      if (holder && holder.dataset.signature !== signature) {
        holder.dataset.signature = signature;
        holder.replaceChildren();
        codes.forEach(function (entry) {
          if (!entry.code) return;
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'cad-discount__code';
          chip.setAttribute('data-cad-discount-remove', entry.code);
          chip.setAttribute('aria-label', 'Remove discount code ' + entry.code);
          chip.textContent = entry.code + (entry.applicable === false ? ' (not applied)' : '') + ' ×';
          holder.appendChild(chip);
        });
      }
      var message = form.querySelector('[data-cad-discount-message]');
      if (message) {
        var copy = discountFeedback ? discountFeedback.message : '';
        if (message.textContent !== copy) message.textContent = copy;
        message.hidden = !copy;
        message.classList.toggle('is-error', !!(discountFeedback && discountFeedback.error));
      }
      var input = form.querySelector('[data-cad-discount-input]');
      if (input) input.setAttribute('aria-invalid', discountFeedback && discountFeedback.error ? 'true' : 'false');
      var apply = form.querySelector('[data-cad-discount-apply]');
      var label = discountFeedback && discountFeedback.pending ? 'Applying…' : 'Apply';
      if (apply && apply.textContent !== label) apply.textContent = label;
    });
  }
  function paintCartAmounts() {
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach(function (root) {
      var state = cartState(root);
      if (!state || !Number.isFinite(state.total)) return;
      root.querySelectorAll('[data-cad-checkout]').forEach(function (button) {
        var copy = 'Checkout ' + cartMoney(state.total, state);
        if (button.textContent !== copy) button.textContent = copy;
      });
      renderDiscounts(root, state);
    });
  }
  function cartRoute(path) {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + path;
  }
  function showDiscountFeedback(message, error, pending) {
    discountFeedback = { message: message, error: !!error, pending: !!pending };
    paintCartAmounts();
  }
  function updateDiscount(form, removeCode) {
    var input = form.querySelector('[data-cad-discount-input]');
    var code = (removeCode || input.value).trim();
    if (!code || code.indexOf(',') !== -1) {
      showDiscountFeedback('Enter one discount code at a time.', true);
      input.focus();
      return;
    }
    if (!beginUpdate()) return;
    var fromDrawer = !!form.closest('cart-drawer');
    var nextInputValue = removeCode ? '' : code;
    var discountUpdated = false;
    showDiscountFeedback(removeCode ? 'Removing code…' : 'Checking your code…', false, true);
    // Fetch once on submission so an existing product/shipping code is not dropped.
    fetch(cartRoute('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      }).then(function (cart) {
        if (!Array.isArray(cart.discount_codes)) throw new Error('Unable to confirm existing codes');
        var codes = cart.discount_codes.map(function (entry) { return entry.code; }).filter(Boolean);
        codes = codes.filter(function (value, index, all) {
          return all.findIndex(function (other) { return other.toLowerCase() === value.toLowerCase(); }) === index;
        });
        if (removeCode) codes = codes.filter(function (value) { return value.toLowerCase() !== code.toLowerCase(); });
        else if (!codes.some(function (value) { return value.toLowerCase() === code.toLowerCase(); })) codes.push(code);
        return mutate(cartRoute('cart/update.js'), { discount: codes.join(',') });
      }).then(function (res) {
        return window.CadianSheetGifts ? window.CadianSheetGifts.normalize(res) : res;
      }).then(function (res) {
        if (!res.sections || !res.sections['cart-drawer']) {
          window.location = cartRoute('cart');
          return;
        }
        swapSections(res, !fromDrawer);
        discountUpdated = true;
        var confirmed = Array.isArray(res.discount_codes);
        var applied = confirmed && res.discount_codes.find(function (entry) { return entry.code.toLowerCase() === code.toLowerCase(); });
        if (removeCode && confirmed && !applied) {
          try {
            var saved = window.localStorage.getItem('cadian_popup_code');
            if (saved && saved.toLowerCase() === code.toLowerCase()) window.localStorage.removeItem('cadian_popup_code');
          } catch (_) { /* Storage can be unavailable in private browsing. */ }
          showDiscountFeedback('Discount code removed. Your price has been updated.');
        } else if (!removeCode && applied && applied.applicable === true) {
          showDiscountFeedback(code + ' applied. Your price has been updated.');
        } else {
          showDiscountFeedback(confirmed ? 'This code is not available for this cart. Check the code or its offer conditions.' : 'We could not confirm this code. Review your cart before checkout.', true);
        }
        nextInputValue = discountFeedback.error && !removeCode ? code : '';
      }).catch(function (error) {
        showDiscountFeedback(error.cartMessage ? error.message : 'We could not confirm the update. Please check your cart before trying again.', true);
      }).finally(function () {
        endUpdate();
        paintCartAmounts();
        var root = document.querySelector(fromDrawer ? 'cart-drawer' : '#main-cart-footer');
        var nextInput = root && root.querySelector('[data-cad-discount-input]');
        if (nextInput) { nextInput.value = nextInputValue; nextInput.focus(); }
        // Navidium's watcher detects line/quantity changes, so a code-only price
        // change also needs its own quote refresh. Use the app's existing entry point.
        if (discountUpdated && typeof nvd_init === 'function') {
          Promise.resolve().then(function () { return nvd_init(); })
            .then(function () { placeNavidium(); syncBusy(); })
            .catch(function () { /* Keep a retained stale quote locked; standard checkout remains available. */ });
        }
      });
  }
  document.addEventListener('submit', function (event) {
    if (!event.target.matches('[data-cad-discount-form]')) return;
    event.preventDefault();
    updateDiscount(event.target);
  });
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cad-discount-remove]');
    if (!button) return;
    event.preventDefault();
    updateDiscount(button.closest('[data-cad-discount-form]'), button.getAttribute('data-cad-discount-remove'));
  });

  var changingLine = false;
  function changeLine(body) {
    if (changingLine || !beginUpdate()) return;
    var d = drawerEl();
    var controls = Array.prototype.slice.call(d.querySelectorAll('[data-qty-inc], [data-qty-dec], [data-line-remove], [data-mode-one], [data-mode-sub], [data-upsell-add], [data-checkout]')).filter(function (button) { return !button.disabled; });
    var alert = d.querySelector('[data-cart-update-error]');
    if (alert) alert.hidden = true;
    changingLine = true;
    controls.forEach(function (button) { button.disabled = true; });
    d.setAttribute('aria-busy', 'true');
    mutate('/cart/change.js', body).then(function (res) {
      return window.CadianSheetGifts ? window.CadianSheetGifts.normalize(res) : res;
    }).then(function (res) {
      if (!res.sections || !res.sections['cart-drawer']) {
        window.location = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        return;
      }
      swapSections(res);
    }).catch(function (error) {
      if (!alert) {
        alert = document.createElement('p');
        alert.setAttribute('data-cart-update-error', '');
        alert.setAttribute('role', 'alert');
        alert.className = 'cad-cart-error';
        var target = d.querySelector('.cad-dw__foot') || d.querySelector('[data-cad-drawer]');
        target.prepend(alert);
      }
      alert.textContent = error.cartMessage ? error.message : "We couldn't confirm the update. Please check your cart before trying again.";
      alert.hidden = false;
    }).finally(function () {
      changingLine = false;
      controls.forEach(function (button) { button.disabled = false; });
      endUpdate();
    });
  }

  window.cadianRefreshCart = function (res, keepClosed) { swapSections(res, keepClosed !== false); };

  /* delegated events */
  document.addEventListener('click', function (e) {
    var d = drawerEl();
    if (!d || !d.contains(e.target)) return;

    var line = e.target.closest('[data-line-key]');
    var key = line ? line.getAttribute('data-line-key') : null;
    var qtyEl = line ? line.querySelector('.cad-qty .q') : null;
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

    if (e.target.closest('[data-qty-inc]') && key) {
      changeLine({ id: key, quantity: qty + 1 });
    } else if (e.target.closest('[data-qty-dec]') && key) {
      changeLine({ id: key, quantity: Math.max(0, qty - 1) });
    } else if (e.target.closest('[data-line-remove]') && key) {
      changeLine({ id: key, quantity: 0 });
    } else if (e.target.closest('[data-mode-sub]') && key) {
      var wrap = e.target.closest('[data-mode-line]');
      var plan = wrap ? parseInt(wrap.getAttribute('data-plan-id'), 10) : null;
      if (plan && !e.target.closest('[data-mode-sub]').classList.contains('on')) {
        changeLine({ id: key, quantity: qty, selling_plan: plan });
      }
    } else if (e.target.closest('[data-mode-one]') && key) {
      if (!e.target.closest('[data-mode-one]').classList.contains('on')) {
        changeLine({ id: key, quantity: qty, selling_plan: null });
      }
    } else if (e.target.closest('[data-upsell-add]')) {
      var addButton = e.target.closest('[data-upsell-add]');
      if (addButton.disabled) return;
      var card = e.target.closest('[data-upsell]');
      if (!card) return;
      if (!beginUpdate()) return;
      var item = { id: parseInt(card.getAttribute('data-upsell-variant'), 10), quantity: 1 };
      var offer = card.getAttribute('data-upsell-offer');
      if (offer === 'cart_socket_19') item.properties = { _cadian_offer: offer };
      var uplan = parseInt(card.getAttribute('data-upsell-plan'), 10);
      if (uplan) item.selling_plan = uplan;
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      var previousLabel = addButton.textContent;
      addButton.textContent = 'Adding…';
      var errorEl = card.querySelector('[role="alert"]');
      if (errorEl) errorEl.hidden = true;
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) card.classList.add('swap');
      // Start the request with the animation, rather than waiting for it to finish.
      mutate('/cart/add.js', { items: [item] }).then(function (res) {
        if (res.status && res.status >= 400) {
          var error = new Error(res.description || res.message || 'Unable to add this product.');
          error.cartMessage = true;
          throw error;
        }
        if (!res.sections || !res.sections['cart-drawer']) {
          window.location = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          return;
        }
        swapSections(res);
      }).catch(function (error) {
        card.classList.remove('swap');
        addButton.disabled = false;
        addButton.setAttribute('aria-busy', 'false');
        addButton.textContent = previousLabel;
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.setAttribute('role', 'alert');
          card.appendChild(errorEl);
        }
        errorEl.hidden = false;
        errorEl.textContent = error.cartMessage ? error.message : "We couldn't confirm the update. Please check your cart before trying again.";
      }).finally(endUpdate);
    }
  });

  function navidiumNodes() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '#nvd-standard-widget-container, .nvd-mini, #nvd-with-checkout-btn, #nvd-without-checkout-btn'
    ));
  }

  function compactNavidium(slot) {
    slot.querySelectorAll('#nvd-standard-widget-container, .nvd-mini').forEach(function (el) {
      el.style.transform = 'none';
      el.style.width = '100%';
      el.style.minHeight = '0';
      el.style.height = 'auto';
      el.style.margin = '0';
      el.style.padding = '6px 0';
    });
  }

  function brandNavidium() {
    var scope = 'cart-drawer, #main-cart-footer';
    document.querySelectorAll(scope).forEach(function (root) {
      root.querySelectorAll('.nvd-std-widget-title').forEach(function (title) {
        if (title.textContent !== 'Delivery Assurance Upgrade') title.textContent = 'Delivery Assurance Upgrade';
      });
      root.querySelectorAll('#nvd-without-checkout-btn').forEach(function (button) {
        button.classList.add('cad-delivery-without');
        var label = button.querySelector('#nvd-subtotal');
        if (label && !button.querySelector('.nvd-cta-loader') && label.textContent !== 'Checkout without Delivery Assurance Upgrade') {
          label.textContent = 'Checkout without Delivery Assurance Upgrade';
        }
      });
      root.querySelectorAll('#nvd-with-checkout-btn').forEach(function (button) {
        var label = button.querySelector('#nvd-subtotal');
        if (!label || button.querySelector('.nvd-cta-loader')) return;
        button.classList.add('cad-delivery-checkout');
        var summary = button.querySelector('.cad-delivery-summary');
        // Keep the existing stale-quote lock and the app's loading state intact.
        if (/^Updating (?:protection|delivery upgrade)/i.test(label.textContent.trim())) {
          if (summary) summary.hidden = true;
          return;
        }
        var widget = button.closest('#nvd-standard-widget-container, .nvd-mini');
        var quote = widget && widget.querySelector('.nvd-std-widget-price');
        var fee = quote && quote.textContent.trim();
        var state = cartState(root);
        var feeCents = quoteCents(fee);
        if (state && Number.isFinite(state.base) && feeCents !== null) {
          // If the quoted upgrade is already in the cart, retain its actual discounted charge.
          var alreadyIncluded = state.insuranceCount === 1 && state.insuranceGross === feeCents;
          var includedCents = alreadyIncluded ? state.insurance : feeCents;
          var checkoutCents = alreadyIncluded ? state.total : state.base + feeCents;
          if (!summary) {
            summary = document.createElement('span');
            summary.className = 'cad-delivery-summary';
            button.appendChild(summary);
          }
          var text = 'Including ' + cartMoney(includedCents, state) + ' Delivery Assurance Upgrade';
          if (summary.textContent !== text) summary.textContent = text;
          summary.hidden = false;
          var checkoutText = 'Checkout ' + cartMoney(checkoutCents, state);
          if (label.textContent !== checkoutText) label.textContent = checkoutText;
          widget.classList.add('cad-delivery-ready');
        } else {
          // A widget version without a readable fee keeps its original fee panel.
          if (summary) summary.hidden = true;
          if (widget) widget.classList.remove('cad-delivery-ready');
          // An unknown app template retains its own priced label and fee panel.
          // Do not invent a quote or overwrite the app's amount.
        }
      });
    });
  }

  function placeNavidium() {
    // Reuse Navidium's buttons and fee; its handlers retain add/remove and checkout.
    paintCartAmounts();
    brandNavidium();
    var slot = document.querySelector('[data-navidium-slot]');
    if (!slot) return;
    navidiumNodes().forEach(function (el) {
      if (el.closest('[data-navidium-slot]')) return;
      if (el.closest('cart-drawer')) slot.appendChild(el);
    });
    compactNavidium(slot);
    hideDuplicateNvdCtas(slot);
  }

  function hideDuplicateNvdCtas(slot) {
    if (!document.querySelector('cart-drawer #nvd-with-checkout-btn')) return;
    slot.querySelectorAll('.nvd-mini button, #nvd-standard-widget-container button').forEach(function (btn) {
      if (btn.id === 'nvd-with-checkout-btn' || btn.id === 'nvd-without-checkout-btn') return;
      btn.style.display = 'none';
    });
  }

  var nvdWatch = null;
  function watchNavidium() {
    if (nvdWatch) return;
    var scheduled = false;
    nvdWatch = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; placeNavidium(); syncBusy(); });
    });
    [drawerEl(), document.getElementById('main-cart-footer')].filter(Boolean).forEach(function (target) {
      nvdWatch.observe(target, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      placeNavidium();
      watchNavidium();
      var bubble = document.getElementById('cart-icon-bubble');
      var badge = bubble && bubble.querySelector('.cad-nav__cart-count');
      if (badge && !badge.hasAttribute('hidden')) paintCadianCartIcon(parseInt(badge.textContent, 10) || 0);
    });
  } else {
    placeNavidium();
    watchNavidium();
  }
})();
